<template>
    <div class="table__responsive">
        <table class="table table__responsive">
            <thead v-if="!loadingSurveys && surveys.length">
                <tr>
                    <th>{{$t('dashboard.surveys.table.header.date')}}</th>
                    <th>{{$t('dashboard.surveys.table.header.template')}}</th>
                    <th>{{$t('dashboard.surveys.table.header.type')}}</th>
                    <th class="table__cell--icon"></th>
                    <th class="table__cell--icon"></th>
                    <th class="table__cell--icon"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-if="loadingSurveys" :key="'loading'" class="table--loading">
                    <td :colspan="COLSPAN">
                        <div class="spinner"></div>
                        <div class="text-center loading_text">{{$t('dashboard.surveys.table.loading')}}</div>
                    </td>
                </tr>

                <tr v-if="!loadingSurveys && !surveys.length" :key="'no-surveys'" class="table--empty">
                    <td :colspan="COLSPAN">
                        <div class="text-center">{{$t('dashboard.surveys.table.no_surveys')}}</div>
                    </td>
                </tr>

                <tr v-for="survey in surveys" :key="survey.id">
                    <td>{{ survey.created_at | formatDate }}</td>
                    <td>{{ survey.survey_template.title }}</td>
                    <td>{{ $t('dashboard.surveys.table.types.' + survey.survey_template.type)}}</td>
                    <td><span @click="viewSurveyAnswers(survey)" v-tooltip.bottom="$t('dashboard.surveys.table.view')" class="table__icon icons icon-eye"></span></td>
                    <td><span @click="editSurvey(survey)" v-tooltip.bottom="$t('dashboard.surveys.table.edit')" class="table__icon icons icon-pencil"></span></td>
                    <td><span @click="showDeleteSurveyModal(survey)" v-tooltip.bottom="$t('dashboard.surveys.table.delete')" class="table__icon icons icon-trash"></span></td>
                </tr>

                <tr class="table__navigation" v-if="surveysMeta && surveysMeta.last_page > 1">
                    <td :colspan="COLSPAN">
                        <pagination :meta="surveysMeta" @goToPage="goToPage"/>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import { saveFile } from '@/helpers';
    import Pagination from '@/components/tables/Pagination';
    import { GET_SURVEYS } from '@/store/modules/surveys';

    @Component({
        components: {
            Pagination,
        }
    })
    export default class ApplicationsTable extends Vue {
        COLSPAN = 5;
        name = 'surveys-table';

        created() {
            this.$store.dispatch(GET_SURVEYS, {});
        }

        get surveys() {
            return this.$store.state.surveys.surveys;
        }

        get loadingSurveys() {
            return this.$store.state.surveys.loading;
        }

        get surveysMeta() {
            return this.$store.state.surveys.surveysMeta;
        }

        goToPage(pageNo) {
            this.$store.dispatch(GET_SURVEYS, { params: { page: pageNo }});
        }

        viewSurveyAnswers(survey) {
            this.$modal.show('survey-answers-modal', { survey });
        }

        editSurvey(survey) {
            this.$modal.show('survey-modal', { survey });
        }

        showDeleteSurveyModal(survey) {
            const content = {
                title: this.$t('modals.delete_survey.title'),
                message: this.$t('modals.delete_survey.message'),
            };
            this.$modal.show('confirmation-modal', { content, callback: this.deleteSurvey, survey});
        }

        deleteSurvey({survey}) {
            survey.remove()
                .then(() => {
                    this.$notify.success(this.$t('notify.survey.delete_success'));
                    this.$store.dispatch(GET_SURVEYS, {});
                })
                .catch(err => this.$notify.error(this.$t('notify.survey.delete_error')));
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/tables/dashboard/SurveysTable.vue